
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiNotificationAdviceActiveTwotone as ObiNotificationAdviceActiveTwotoneElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-notification-advice-active-twotone.js';
 
 
 

 
 export const ObiNotificationAdviceActiveTwotone = createComponent({
   react: React,
   tagName: 'obi-notification-advice-active-twotone',
   elementClass: ObiNotificationAdviceActiveTwotoneElement,
   events: {
     
   }
  });
 
 